module.exports = {
    // basic
    'profile': 'profile',
    'contact-and-message-delivery': 'contact and message delivery',
    'sms-delivery-method': 'text delivery method',
    'entries-per-page': 'entries per page',
    'page-options': 'page options',
    'drop-down-keep-open-on-select': 'keep dropdown list open when selecting multiple values',
    'entry-page-options': 'upload / entry edit',
    'send-test-email': 'send test email',
    'send-test-message': 'send test message',

    // raw
    'send-test-email-succeeded': 'Send test email succeeded.',
    'send-test-email-failed': 'Send test email failed.',
    'send-test-message-succeeded': 'Send test message succeeded.',
    'send-test-message-failed': 'Send test message failed.',

    // template
    'my-account-mobile-help': (words) => `<b>${words[0]}</b> information will be used to send any text notifications you subscribe to. If this is your first time using your account, or you are changing your mobile number, you can click <b>${words[1]}</b> to help ensure proper message delivery.`,
    'my-account-email-help': (words) => `<b>${words[0]}</b> will be used for any email notifications you subscribe to. If this is your first time using your account, or you are changing your email address, you can click <b>${words[1]}</b>, to help ensure proper message delivery.`,

};
